/* eslint-disable no-case-declarations */
import {
    GESTION_OPERATIVA_GET_SALE_BEGIN,
    GESTION_OPERATIVA_GET_SALE_SUCCESS,
    GESTION_OPERATIVA_GET_SALE_FAILURE,
    GESTION_OPERATIVA_GET_SALE_DISMISS_ERROR,
  } from '../constants'
import { cloneDeep } from 'lodash'
import { calculateMaximoDescuentoFromSale } from '../../../common/Utilities'

export function reducer(state, action) {
    switch (action.type) {
      case GESTION_OPERATIVA_GET_SALE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          getSalePending: true,
          getSaleError: null,
          sale: null,
        }
  
      case GESTION_OPERATIVA_GET_SALE_SUCCESS:
        // The request is success
        const { sale, takingCars, permissions } = action.data
        const bonificacionConcesionaria = sale.reservation_discounts ? {} : { bonificacionConcesionaria: sale.Bonifications?.car_lot_amount }

        return {
          ...state,
          getSalePending: false,
          getSaleError: null,
          sale: {
            ...sale,
            auto: {
              ...sale.auto,
              resale_price_increase: sale.resale_price_increase 
              // Stocks: newStocksWithRules,
            },
            bill: sale.Bills?.find(item => item.status === 'ACTIVA'),
            Taking_cars: cloneDeep(takingCars),
            ...bonificacionConcesionaria
          },
          peritaciones: {},
          savedSale: true,
          initialBonAdicional: sale.additional_discount,
          initialBonEspecial: sale.special_discount,
          // clonar data
          client_license_plate: sale.client_license_plate,
          initial_client_license_plate: sale.client_license_plate,
          initial_delivery_costs: sale.delivery_costs,
          initial_delivery_costs_original: sale.delivery_costs_original,
          delivery_costs_manually_edited: false,
          client_id: sale.client_id,
          catalog_id: sale.catalog_id,
          stock_id: sale.stock_id,
          isModified: state.isModified || sale.open_price_old_value > 0,
          cliente: cloneDeep(sale.cliente),
          maximoDescuento: calculateMaximoDescuentoFromSale(sale, { permissions })
        }
  
      case GESTION_OPERATIVA_GET_SALE_FAILURE:
        // The request is failed
        return {
          ...state,
          getSalePending: false,
          getSaleError: action.data.error,
          sale: null,
        }
  
      case GESTION_OPERATIVA_GET_SALE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          getSaleError: null,
        }
  
      default:
        return state
    }
  }